/* eslint-disable */
// 检测浏览器类型
export const getBrowser = () => {
    const ua = window.navigator.userAgent;
    const isIE = window.ActiveXObject != undefined && ua.indexOf('MSIE') != -1;
    const isFirefox = ua.indexOf('Firefox') != -1;
    const isOpera = window.opr != undefined;
    const isChrome = ua.indexOf('Chrome') && window.chrome;
    const isSafari = ua.indexOf('Safari') != -1 && ua.indexOf('Version') != -1;

    if (isIE) {
        return 'IE';
    } else if (isFirefox) {
        return 'Firefox';
    } else if (isOpera) {
        return 'Opera';
    } else if (isChrome) {
        return 'Chrome';
    } else if (isSafari) {
        return 'Safari';
    } else {
        return 'Unkown';
    }
};
